module.exports = __webpack_public_path__ + "img/levelup-icon-invoice.3206de92.svg";